export default __webpack_public_path__ + "static/media/emoji_clap.67d78ec9.png";